var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2A37",
    d: "M18.25.25H1.75a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V1.75a1.5 1.5 0 0 0-1.5-1.5M7 14.5a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.5 0zM6.25 7a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25m9 7.5a.75.75 0 1 1-1.5 0v-3.375a1.875 1.875 0 1 0-3.75 0V14.5a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.48-.167 3.375 3.375 0 0 1 5.27 2.792z"
  })));
};
export default SvgLinkedIn;